import { Collapse } from 'antd'
import styled from 'styled-components'

const StyledMenuTitleCollapsePanel = styled(Collapse.Panel)`
  .ant-collapse-content-box {
    padding: 0;
  }
`

export default StyledMenuTitleCollapsePanel
